<template>
  <div class="relative w-full text-left">
    <div class="relative">
      <div
        :class="[
          'w-full px-3 border rounded-md cursor-pointer flex items-center gap-2', 
          isError ? 'border-red-300' : 'border-gray-300 hover:border-gray-400',
          (isError && selectedValues.length === 0) ? 'bg-red-300' : 'bg-gray-50'
        ]"
        @click="toggleDropdown"
      >
        <div class="flex items-center flex-1 h-full gap-1 py-2 overflow-x-auto">
          <div
            v-for="option in selectedOptions"
            :key="option.value"
            class="inline-flex items-center px-2 py-0.5 text-xs text-blue-800 bg-blue-100 rounded-lg flex-shrink-0 h-6"
          >
            <span>{{ option.text || option.name }}</span>
            <button
              @click.stop="removeOption(option.value)"
              class="ml-1 text-sm leading-none text-blue-600 hover:text-blue-800 focus:outline-none"
            >
              ×
            </button>
          </div>

          <span
            v-if="selectedValues.length === 0"
            class="flex-shrink-0 text-sm"
            :class="isError ? 'text-red-500' : 'text-gray-500'"
            :style="{ padding: '2px 0' }"
          >
            {{ defaultText }}
          </span>
        </div>

        <ChevronDownFilled
          className="h-3 w-3 text-gray-500 pointer-events-none flex-shrink-0"
        />
      </div>
    </div>

    <div v-if="isOpen" class="absolute right-0 z-10 w-full mt-1 bg-white border rounded-md shadow-sm ring-1 ring-black ring-opacity-5">
      <div class="p-1">
        <label
          v-for="option in options"
          :key="option.value"
          class="flex items-center p-2 m-0 cursor-pointer hover:bg-gray-100"
          @click="selectOption(option)"
        >
          <input
            type="checkbox"
            :value="option.value"
            :checked="selectedValues.includes(option.value)"
            @change="handleCheckboxChange(option)"
            class="w-4 h-4 text-blue-600 form-checkbox"
          />
          <span class="ml-2 text-gray-700">{{ option.text || option.name }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import ChevronDownFilled from '@/components/icons/ChevronDownFilled';

export default {
  name: 'SelectCheckbox',
  components: {
    ChevronDownFilled
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    defaultText: {
      type: String,
      default: 'Select options'
    },
    options: Array,
    isError: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isOpen: false,
      selectedValues: Array.isArray(this.value) ? this.value : []
    };
  },
  computed: {
    selectedOptions() {
      return this.options.filter(option =>
        this.selectedValues.includes(option.value)
      );
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectOption(option) {
      this.handleCheckboxChange(option);
      this.isOpen = false;
    },
    handleCheckboxChange(option) {
      const index = this.selectedValues.indexOf(option.value);
      if (index > -1) {
        this.selectedValues.splice(index, 1);
      } else {
        this.selectedValues.push(option.value);
      }
      this.$emit('input', this.selectedValues);
    },
    removeOption(value) {
      const index = this.selectedValues.indexOf(value);
      if (index > -1) {
        this.selectedValues.splice(index, 1);
        this.$emit('input', this.selectedValues);
      }
    },
    handleClickOutside(event) {
      if (this.isOpen && !this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    }
  },
  watch: {
    value(newValue) {
      this.selectedValues = Array.isArray(newValue) ? newValue : [];
    }
  }
}
</script>